<template>
    <div class="container-destination border">
        <div class="border text-secondary p-3 d-flex d-sm-none" @click="back()">
            <span class="font-icons icons-arrow-back mr-2 cursor-pointer"></span>
            <span>{{ __('messages.back_to_list') }}</span>
        </div>

        <div v-if="screensize <= 576" class="d-sm-none pdv-map-mobile">
            <pdv-map :active="true" :places="[branch]" :dispatch="dispatch" :selected="branch"></pdv-map>
        </div>

        <div class="pdv-swipe-mobile border shadow" ref="swipeInfo">

            <div id="visibleCard" ref="visibleCard" @touchmove="touchMove($event)" @touchend="touchEnd($event)">
                <div class="w-100 text-center text-gray pt-1 d-sm-none">
                    <span class="font-icons"
                        :class="{ 'icons-chevron-up': !activeCard, 'icons-chevron-down': activeCard }"></span>
                </div>

                <p class="px-4 pt-sm-4">
                    <strong>
                        {{ branch.displayNameShort }}
                    </strong><br />
                    <span>
                        {{ branch.city }}, {{ branch.stateName }}
                    </span> <br />

                    <span class="text-success" v-if="isOpen">
                        {{ __('messages.open') }}
                    </span>
                    <span class="text-danger" v-if="!isOpen">
                        {{ __('messages.closed') }}
                    </span>
                </p>

                <p class="px-4">
                    <!--  <button class="btn btn-secondary mr-4">
        <span class="font-icons icons-location icon-small-pdv"></span> Indicaciones
    </button> -->

                    <a v-if="branch.phone" class="link"
                       :href="'tel:' + branch.phone">
                        <span class="font-icons icons-phone icon-small-pdv"></span>
                        {{ __('messages.call') }}
                    </a>
                    <a v-if="branch.whatsAppLink" class="wa-contact-link" :href="branch.whatsAppLink" target="_blank" rel="noopener noreferrer">
                        <i class="icons-whatsapp font-green"></i>
                        <span class="font-green">{{ __('messages.wa_contact') }}</span>
                    </a>
                </p>
            </div>

            <hr>

            <div class="scroller-card">
                <div class="d-inline-flex mt-2 px-4">
                    <span class="font-icons icons-location text-secondary icon-small-pdv mr-3"></span>
                    <p>
                        <b>{{ __('messages.address') }}:</b> <br />
                        <span v-html="branch.address"></span>

                        <br />
                        <b v-if="branch.addressReference">{{ __('messages.references') }}:</b> <br />

                        <span v-html="branch.addressReference"></span>
                    </p>
                </div>
                <br />
                <div class="d-inline-flex mt-2 px-4">
                    <span class="font-icons icons-clock text-secondary icon-small-pdv mr-3"></span>
                    <p>
                        <b>{{ __('messages.schedule') }}:</b> <br />

                        <span v-html="branch.businessHours"></span>

                        <br />

                        <span class="text-success" v-if="isOpen">
                            {{ __('messages.open') }}
                        </span>
                        <span class="text-danger" v-if="!isOpen">
                            {{ __('messages.closed') }}
                        </span>
                    </p>
                </div>
                <br />
                <div class="d-inline-flex mt-2 px-4" v-if="branch.phone">
                    <span class="font-icons icons-phone text-secondary icon-small-pdv mr-3"></span>
                    <p>
                        <b>{{ __('messages.phone') }}:</b> <br />

                        {{ branch.phone }}

                        <br />
                        <span class="d-none">_</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { PdvServices } from '../../services/PdvService';

let pdvs = PdvServices.GetPlaces();
export default {
    props: {
        branch: Object,
        dispatch: Object
    },
    mounted() {
        if (window.screen.width <= 576) {
            let container = this.$refs['swipeInfo'];
            this.topInitial = this.branch.phone ? 180 : 120;
            container.style.height = this.topInitial + 'px';
        }

        this.checkIfIsOpen();

    },
    data() {
        return {
            selected: null,
            activeCard: false,
            topInitial: 0,
            screensize: window.screen.width,
            isOpen: false,
            branches: pdvs.branchs
        };
    },
    methods: {
        back() {
            document.body.style.overflow = 'auto';
            this.$emit('closed', true);
        },
        toggleSwip() {
            this.activeCard = !this.activeCard;

            /* if (this.activeCard) {
                this.$refs['swipeInfo'].style.top = '100px';
            } else {
                this.$refs['swipeInfo'].style.top = this.topInitial + 'px';
            } */
        },
        onMouseDown() {

        },
        touchMove(e) {
            let container = this.$refs['swipeInfo'];
            container.style.transition = 'none';
            let touchLocation = e.targetTouches[0];
            let toppos = window.innerHeight - touchLocation.clientY;
            if (toppos >= this.topInitial && toppos <= window.innerHeight * 0.75) {
                container.style.height = toppos + 'px';
            }
        },
        touchEnd(e) {
            let container = this.$refs['swipeInfo'];
            container.style.transition = 'all ease-out 0.5s';
            let touchLocation = e.changedTouches[0];
            let toppos = window.innerHeight - touchLocation.clientY;
            let middlePoint = window.innerHeight * 0.50;
            if (toppos > middlePoint) {
                container.style.height = window.innerHeight * 0.75 + 'px';
                this.activeCard = true;
            } else {
                container.style.height = this.topInitial + 'px';
                this.activeCard = false;
            }


        },
        checkIfIsOpen() {
            if (this.branch.businessHours) {
                const splitBussinesHour = this.branch.businessHours.split('<br/>');

                if (splitBussinesHour.length > 1) {
                    const removeSpaces = splitBussinesHour[1].replaceAll(' ', '').replace('hrs', '').replaceAll(':00', '');
                    const rangeSchedule = removeSpaces.split('-');
                    const currentTimeHour = new Date().getHours();

                    if (rangeSchedule.length > 1) {
                        if (rangeSchedule[0] <= currentTimeHour && rangeSchedule[1] >= currentTimeHour) {
                            this.isOpen = true;
                        }
                    }
                }
            }
        }
    }
};
</script>
    